import { EntraIdIconUrl } from "@p0security/shared/integrations/constants";
import { EntraIdComponents } from "@p0security/shared/integrations/directories/azure-ad/components";
import { Typography } from "antd";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { entraIdInstaller } from "./install";

const EntraIdPreamble = (
  <>
    <Typography.Paragraph>
      Enable just-in-time access to Entra Directory Roles with a dedicated
      Security perimeter for secure role assignments.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>Entra tenant ID</li>
      <li>Cloud computing environment for Security perimeter deployment</li>
    </ul>
  </>
);

export const EntraId = (
  props: Pick<
    InstallProps<typeof EntraIdComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "tenant", []);

  return (
    <Install<typeof EntraIdComponents>
      components={EntraIdComponents}
      installer={entraIdInstaller}
      integration="entra-id"
      itemKind={itemKind}
      logo={EntraIdIconUrl}
      preamble={EntraIdPreamble}
      title={"Entra ID"}
      {...props}
    />
  );
};
